module.exports = __webpack_public_path__ + "img/earth.87e5782d.svg";